export enum ERegimeTributario
{
    SimplesNacional = 1,
    SimplesNacionalExcessoSubLimiteReceita = 2,
    LucroPresumido = 3,
    LucroReal = 4,
    LucroArbitrado = 5,
    Imune = 6,
}
